import React from 'react';
import './Contato.css';

const Contato: React.FC = () => {
  return (
    <section id="contato" className="contato">
      <div className="container">
        <h2 className="section-title">Contato para Vendas</h2>
        <p className="section-subtitle">
          Entre em contato conosco para solicitar orçamentos, esclarecer dúvidas 
          ou fazer seu pedido. Estamos prontos para atendê-lo!
        </p>
        
        <div className="contato-content">
          <div className="contato-info">
            <div className="contato-pessoa">
              <h3>Falar com Aneilimar Quintino</h3>
              <p>Responsável pelas vendas</p>
            </div>
            
            <div className="contato-detalhes">
              <div className="contato-item">
                <div className="contato-icon">📱</div>
                <div className="contato-text">
                  <strong>WhatsApp / Telefone</strong>
                  <p>(34) 99780-0202</p>
                  <a href="tel:+5534997800202" className="contato-link">
                    Ligar Agora
                  </a>
                </div>
              </div>
              
              <div className="contato-item">
                <div className="contato-icon">✉️</div>
                <div className="contato-text">
                  <strong>E-mail</strong>
                  <p>vendas@garciasmilho.com.br</p>
                  <a href="mailto:vendas@garciasmilho.com.br" className="contato-link">
                    Enviar E-mail
                  </a>
                </div>
              </div>
              
              <div className="contato-item">
                <div className="contato-icon">📍</div>
                <div className="contato-text">
                  <strong>Endereço</strong>
                  <p>Rua dos Pianos 633C<br />Taiaman, Uberlândia - MG</p>
                </div>
              </div>
              
              <div className="contato-item">
                <div className="contato-icon">🏢</div>
                <div className="contato-text">
                  <strong>Dados da Empresa</strong>
                  <p>CNPJ: 17.475.403/0001-90</p>
                  <p>Insc. Est: 002089505.00-05</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="contato-whatsapp">
            <div className="whatsapp-card">
              <div className="whatsapp-icon">💬</div>
              <h3>Vendas por WhatsApp</h3>
              <p>
                Fale conosco diretamente pelo WhatsApp para um atendimento 
                mais rápido e personalizado!
              </p>
              <a 
                href="https://wa.me/5534997800202?text=Olá! Gostaria de saber mais sobre os produtos Garcias Milho." 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn-whatsapp"
              >
                <span className="whatsapp-icon-btn">📱</span>
                Falar no WhatsApp
              </a>
            </div>
            
            <div className="horario-atendimento">
              <h4>Horário de Atendimento</h4>
              <div className="horarios">
                <div className="horario">
                  <span>Segunda a Sexta:</span>
                  <span>08:00 às 18:00</span>
                </div>
                <div className="horario">
                  <span>Sábado:</span>
                  <span>08:00 às 12:00</span>
                </div>
                <div className="horario">
                  <span>Domingo:</span>
                  <span>Fechado</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contato;
